import AmpleHireLoader from "./ample-hire-loader";

const AmpleHireTableLoader = () => {
  return (
    <div
      style={{
        height: "60vh",
      }}
    >
      <AmpleHireLoader />
    </div>
  );
};

export default AmpleHireTableLoader;
